import React from "react";
var __jsx = React.createElement;
import TextSearchComponent from "@/pages/serviceCenters/ServiceCentersComponents/ServiceCentersComponent/Components/TextSearchComponent/TextSearchComponent";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
import stl from "./Form.module.css";
var Form = function Form(_ref) {
  var _availableSCData$make, _availableSCData$citi, _availableSCData$citi2, _availableSCData$waka, _availableSCData$waka2, _availableSCData$waka3, _availableSCData$waka4;
  var t = _ref.t,
    onFieldChange = _ref.onFieldChange,
    fields = _ref.fields,
    availableSCData = _ref.availableSCData,
    onSubmit = _ref.onSubmit,
    loading = _ref.loading;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.sCentersContainer
  }, /*#__PURE__*/React.createElement(TextSearchComponent, {
    minLengthForSearch: 1,
    name: "make_id",
    label: t("look_brand", {
      ns: "web_service_centers"
    }),
    value: fields.make_id.value,
    disabled: false,
    data: availableSCData === null || availableSCData === void 0 ? void 0 : (_availableSCData$make = availableSCData.makes) === null || _availableSCData$make === void 0 ? void 0 : _availableSCData$make.map(function (make) {
      return {
        key: make.id,
        name: make.name,
        image: make === null || make === void 0 ? void 0 : make.logo
      };
    }),
    getData: function getData() {
      var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      onFieldChange(v, "make_id");
    },
    className: stl.inFront,
    errorMsg: t("there_service_centers_make", {
      ns: "web_service_centers"
    }),
    onFieldChange: onFieldChange
  }), /*#__PURE__*/React.createElement(TextSearchComponent, {
    minLengthForSearch: 1,
    name: "city_id",
    label: t("choose_city", {
      ns: "web_service_centers"
    }),
    value: fields.city_id.value,
    disabled: !fields.make_id.value || loading ?
    // || availableSCData?.cities?.length <= 0
    true : false,
    data: availableSCData === null || availableSCData === void 0 ? void 0 : (_availableSCData$citi = availableSCData.cities) === null || _availableSCData$citi === void 0 ? void 0 : _availableSCData$citi.map(function (make) {
      return {
        key: make.id,
        name: make.name
      };
    }),
    getData: function getData() {
      var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      onFieldChange(v, "city_id");
    },
    className: stl.inFront2,
    errorMsg: t("there_service_centers_city", {
      ns: "web_service_centers"
    }),
    isShowError: fields.make_id.value !== "" && (availableSCData === null || availableSCData === void 0 ? void 0 : (_availableSCData$citi2 = availableSCData.cities) === null || _availableSCData$citi2 === void 0 ? void 0 : _availableSCData$citi2.length) <= 0 ? true : false,
    makeIdValue: fields.make_id.value
  }), /*#__PURE__*/React.createElement(TextSearchComponent, {
    minLengthForSearch: 1,
    name: "dealership_name",
    label: t("choose_dealership", {
      ns: "web_service_centers"
    }),
    value: fields.city_id.value == "" ? "" : fields.dealership_name.value,
    disabled: !fields.make_id.value || loading || fields.city_id.name === "" || (availableSCData === null || availableSCData === void 0 ? void 0 : (_availableSCData$waka = availableSCData.wakalat) === null || _availableSCData$waka === void 0 ? void 0 : _availableSCData$waka.length) <= 0 ? true : false,
    data: availableSCData === null || availableSCData === void 0 ? void 0 : (_availableSCData$waka2 = availableSCData.wakalat) === null || _availableSCData$waka2 === void 0 ? void 0 : _availableSCData$waka2.map(function (make) {
      return {
        key: make.id,
        name: make.name
      };
    }),
    getData: function getData() {
      var v = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      onFieldChange(v, "dealership_name");
    },
    errorMsg: fields.make_id.name !== "" && fields.city_id.name === "" ? "" : loading === true ? "" : (availableSCData === null || availableSCData === void 0 ? void 0 : (_availableSCData$waka3 = availableSCData.wakalat) === null || _availableSCData$waka3 === void 0 ? void 0 : _availableSCData$waka3.length) <= 0 && t("there_service_centers_dealership", {
      ns: "web_service_centers"
    }),
    isShowError: fields.make_id.value !== "" && (availableSCData === null || availableSCData === void 0 ? void 0 : (_availableSCData$waka4 = availableSCData.wakalat) === null || _availableSCData$waka4 === void 0 ? void 0 : _availableSCData$waka4.length) <= 0 ? true : false,
    makeIdValue: fields.make_id.value
  }), /*#__PURE__*/React.createElement(SubmitButton, {
    className: stl.btn,
    disabled: !fields.make_id.value,
    onClick: function onClick() {
      onSubmit();
    },
    loading: false
  }, t("search", {
    ns: "web_service_centers"
  }))));
};
export default Form;